import { render, staticRenderFns } from "./VoucherManagement.vue?vue&type=template&id=2f89e146"
import script from "./VoucherManagement.vue?vue&type=script&lang=js"
export * from "./VoucherManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports